import React from 'react';

const TriOraha = () => {
    return (
        <div>
            <p>
                Home page - Video landing page
            </p>
            
        </div>
    )
}
export default TriOraha;